

















































import Vue from 'vue'
import Component from 'vue-class-component'
import Modal from '@/components/Modal.vue'
import { EStatementStatuses } from '@zunta/configurations'

@Component({
  props: {
    sentMailResult: {
      type: Object,
      required: false
    },
    customBatchId: {
      type: Number,
      required: false
    },
    showReview: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  components: {
    Modal
  }
})
export default class StatementsMailSuccessModal extends Vue {
  EStatementStatuses: any = EStatementStatuses;
  get batchID () {
    return this.$props.customBatchId || this.$route.params.id
  }
}
